import api from "./index";

// Fetch latest TensoAI blog feed 
export async function fetchBlogFeed() {
  const res = await api.get("/feed/grabBlog");
  return res.data; // raw XML string
}
